export class LoadCreatedFormId {
    public static readonly type = "[Form Templates] Load created form id";

    constructor(public payload: string) {}
}
